<div class="container-fluid">
  <app-main-navbar></app-main-navbar>
  <div class="row row-buttons">
    <div class="col-12 top-buttons mt-3 mb-5">
      <button class="btn main-buttons"
        [ngClass]="{ 'active': thematic_search_type === 'combined_search' }"
        (click)="selectThemeSearchType('combined_search')">
        Thematic Search
      </button>

      <button class="btn main-buttons"
        [ngClass]="{ 'active': thematic_search_type === 'custom_search' }"
        (click)="selectThemeSearchType('custom_search')">
        Advanced Mode
      </button>
    </div>
  </div>

  <div class="row card-row">
    <div class="col-12 card-col" *ngIf="thematic_search_type === 'combined_search'">
      <app-combined-search></app-combined-search>
    </div>

    <div *ngIf="thematic_search_type === 'custom_search'">
      <app-custom-search></app-custom-search>
    </div>
  </div>
</div>
